export const browserItens = [
  {
    name: 'Adquirir token',
    header: [
      'Método: POST',
      'Códigos dos produtos: 1 = Trator, 2 = Helicóptero, 3 = Semi reboque, 4 = Carroceria, 5 = Ônibus e Caminhão, 6 = Colheitadeira',
      'Headers: {"{"Content-Type": "application/json"}"}',
      'Link: https://service.tabelasomos.com.br/user/token/',
      'body: {"username":"Nome do usuário", "password":"Senha do usuário"}',
    ],
    code: `myHeaders = new Headers({\n   "Content-Type": "application/json",\n   })\n\nfetch('https://service.tabelasomos.com.br/user/token/', {\n   method: 'POST',\n   headers: myHeaders,\n   mode: 'cors',\n   cache: 'default',\n   body:{\n       username:"Nome do usuário",\n       password:"Senha do usuário"\n   }\n})  \n  \nRetorno JSON: \n \n{\n  "refresh": \n     "eyJ0eXAiOiJKV1QiLCJhbG..." \n  "access": \n     "Mjk3MDI3NDgsImp0aS..."\n  ... \n}`,
    text: 'Para realização da consulta, primeiramente é necessário requerir um token com um usuário que tenha acesso a integração para confirmaçao do usuário logado, sabendo disso, para integração deverá ser realizada uma requisição como esta:',
    step: 1,
  },
  {
    name: 'Requisição de Datas de Referência',
    header: [
      'Método: GET',
      'Link: https://service.tabelasomos.com.br/table/search/reference-dates/{Código do produto}/',
      'Códigos dos produtos válidos: 1 = Trator, 2 = Helicóptero, 3 = Semi reboque, 4 = Carroceria, 6 = Colheitadeira',
      'Headers: {"Content-Type": "application/json", "Authorization":"Token adquirido na rota anterior"}',
      'Parâmetros opcionais: month_reference (caso informado, retorna os anos disponíveis para o mês)',
    ],
    code: `//Códigos dos produtos válidos: 1 = Trator, 2 = Helicóptero, 3 = Semi reboque, 4 = Carroceria, 6 = Colheitadeira

myHeaders = new Headers({
   "Content-Type": "application/json",
   "Authorization":"Token adquirido na rota anterior"
})

// Exemplo
fetch('https://service.tabelasomos.com.br/table/search/reference-dates/{Código do produto}/', {
   method: 'GET',
   headers: myHeaders,
   mode: 'cors',
   cache: 'default'
})

// Retorno
{ results: 
  [
    {
        "year_reference": 2025,
        "month_reference": 11
    },
    ...
  ]
}
`,
text: '<strong>Passo 1:</strong> Autenticação token. <br/>O usuário poderá consultar as datas de referência disponíveis para cada produto. <strong>Sem passar o parâmetro <code>month_reference</code></strong>, o retorno traz os meses disponíveis. <strong>Passando o parâmetro</strong>, o retorno traz os anos correspondentes a esse mês.',
    step: 2,
  },
  {
    name: 'Requisição de Listagem de Marcas',
    header: [
      'Método: GET',
      'Link: https://service.tabelasomos.com.br/table/search/mounter/"{Código do produto}"/?month_reference={mês}&year_reference={ano}',
      'Códigos dos produtos: 1 = Trator, 2 = Helicóptero, 3 = Semi reboque, 4 = Carroceria, 5 = Ônibus e Caminhão, 6 = Colheitadeira',
      'Headers: {"Content-Type": "application/json, "Authorization":"Token adquirido na rota anterior"}',
      'Parâmetros opcionais: month_reference, year_reference',

    ],
    code: `//Códigos dos produtos: 1 = Trator, 2 = Helicóptero, 3 = Semi reboque, 4 = Carroceria, 5 = Ônibus e Caminhão, 6 = Colheitadeira\n\nmyHeaders = new Headers({\n   "Content-Type": "application/json"\n   "Authorization":"Token adquirido na rota anterior"\n})\n\nfetch('https://service.tabelasomos.com.br/table/search/mounter/"{Código do produto}"/?month_reference={mês}&year_reference={ano}"/', {\n   method: 'GET',\n   headers: myHeaders,\n   mode: 'cors',\n   cache: 'default'\n}) \n\nRetorno JSON: \n\n{ \n   "user": {\n       "id": "6175bf3f-3..."\n       ...\n   },\n   "content": [\n       {\n           "mounter_code": "código do fabricante",\n           "mounter": "fabricante"\n       },  \n       {\n           "mounter_code": "código do fabricante",\n           "mounter": "fabricante"\n       }, \n       ... \n   ]\n}`,
    text: '<strong>Passo 1:</strong> Autenticação token;<br/><strong>Passo 2:</strong> Listagem de Mês/Ano de referência.<br/>O usuário deverá requerir a listagem de Marcas para realizar a consulta, lembrando sempre de passar o token no header da requisição, que ficará assim:',
    step: 3,
  },
  {
    name: 'Requisição de Listagem de Modelos por Marca',
    header: [
      'Método: GET',
      'Link: https://service.tabelasomos.com.br/table/search/codes/"{Código do produto}"/"{Código da marca desejada}"/?month_reference={mês}&year_reference={ano}',
      'Códigos dos produtos: 1 = Trator, 2 = Helicóptero, 3 = Semi reboque, 4 = Carroceria, 5 = Ônibus e Caminhão, 6 = Colheitadeira',
      'Headers: {"Content-Type": "application/json, "Authorization":"Token adquirido na rota anterior"}',
      'Parâmetros opcionais: month_reference, year_reference',

    ],
    code: `//Códigos dos produtos: 1 = Trator, 2 = Helicóptero, 3 = Semi reboque, 4 = Carroceria, 5 = Ônibus e Caminhão, 6 = Colheitadeira\n\nmyHeaders = new Headers({\n   "Content-Type": "application/json"\n   "Authorization":"Token adquirido na rota anterior"\n})\n\nfetch('https://service.tabelasomos.com.br/table/search/codes/"{Código do produto}"/"{Código da marca desejada}"/?month_reference={mês}&year_reference={ano}', {\n   method: 'GET',\n   headers: myHeaders,\n   mode: 'cors',\n   cache: 'default'\n}) \n\nRetorno JSON: \n\n{ \n   "user": {\n       "id": "6175bf3f-3..."\n       ...\n   },\n   "content": [\n       {\n           "mounter": "fabricante",\n           "model": "modelo"\n           "model_code": "código do modelo"\n           "description": "descrição do produto"       \n       }, \n       {\n           "mounter": "fabricante",\n           "model": "modelo"\n           "model_code": "código do modelo"\n           "description": "descrição do produto"\n       }       \n       ... \n   ]\n}`,
    text: '<strong>Passo 1:</strong> Autenticação token;<br/><strong>Passo 2:</strong>  Listagem de Mês/Ano de referência;<br/><strong>Passo 3:</strong>  Requisição de Listagem de Marcas.<br/>Após ter a Marca desejada em mãos, enviar uma das Marcas na url para que sejam listados os modelos disponíveis daquela Marca, como no código abaixo:',
    step: 4,
  },
  {
    name: 'Requisição de listagem de Anos',
    header: [
      'Método: GET',
      'Link: https://service.tabelasomos.com.br/table/search/model/"{Código do produto}"/"{Código do modelo desejada}"/?month_reference={mês}&year_reference={ano}',
      'Códigos dos produtos: 1 = Trator, 2 = Helicóptero, 3 = Semi reboque, 4 = Carroceria, 5 = Ônibus e Caminhão, 6 = Colheitadeira',
      'Headers: {"Content-Type": "application/json, "Authorization":"Token adquirido na rota anterior"}',
      'Parâmetros opcionais: month_reference, year_reference',

    ],
    code: `//Códigos dos produtos: 1 = Trator, 2 = Helicóptero, 3 = Semi reboque, 4 = Carroceria, 5 = Ônibus e Caminhão, 6 = Colheitadeira\n\nmyHeaders = new Headers({\n   "Content-Type": "application/json"\n   "Authorization":"Token adquirido na rota anterior"\n})\n\nfetch('https://service.tabelasomos.com.br/table/search/model/"{Código do produto}"/"{Código do modelo desejada}"/?month_reference={mês}&year_reference={ano}', {\n   method: 'GET',\n   headers: myHeaders,\n   mode: 'cors',\n   cache: 'default'\n}) \n\nRetorno JSON: \n\n{\n   "user": {\n       "id": "6175bf3f-3..."\n       ...\n   },\n   "content": [\n       {\n          "model": "modelo",\n          "mounter": "fabricante",\n          "somos_code": "código somos",\n          "years": [\n             "ano",\n             ...\n          ]\n       }\n    ]\n}`,
    text: '<strong>Passo 1:</strong> Autenticação token;<br/><strong>Passo 2:</strong>  Listagem de Mês/Ano de referência;<br/><strong>Passo 3:</strong>  Requisição de Listagem de Marcas;<br/><strong>Passo 4:</strong> Requisição de Listagem de Modelos por Marca.<br/>Após ter adquirido o modelo desejado, irá faltar somente listar os anos, assim, tendo todas as informações necessárias para fazer a consulta de preço, abaixo um código exemplo da listagem de anos referente ao modelo escolhido:',
    step: 5,
  },
  {
    name: 'Consulta Final',
    header: [
      'Método: GET',
      'Link: https://service.tabelasomos.com.br/table/search/model/price/"{Código do produto}"/"{Código do modelo desejada}"/"{Ano desejado}"/?month_reference={mês}&year_reference={ano}',
      'Códigos dos produtos: 1 = Trator, 2 = Helicóptero, 3 = Semi reboque, 4 = Carroceria, 5 = Ônibus e Caminhão, 6 = Colheitadeira',
      'Headers: {"Content-Type": "application/json, "Authorization":"Token adquirido na rota anterior"}',
      'Parâmetros opcionais: month_reference, year_reference',
    ],
    code: `//Códigos dos produtos: 1 = Trator, 2 = Helicóptero, 3 = SemiReboque, 4 = Carroceria, 5 = Ônibus e Caminhão, 6 = Colheitadeira\n\nmyHeaders = new Headers({\n   "Content-Type": "application/json"\n   "Authorization":"Token adquirido na rota anterior"\n   })\n\nfetch('https://service.tabelasomos.com.br/table/search/model/price/"{Código do produto}"/"{Código do modelo desejada}"/"{Ano desejado}"/?month_reference={mês}&year_reference={ano}', {\n   method: 'GET',\n   headers: myHeaders,\n   mode: 'cors',\n   cache: 'default'\n}) \n\n Retorno JSON:\n\n{\n   "user": {\n       "id": "6175bf3f-3..."\n       ...\n   },\n   "content": {\n        "pricing": null,  // precificação\n        "values": [\n           {\n               "somos_code": "código somos",\n               "type": "código do produto",\n               "mounter": "fabricante",\n               "model": "modelo",\n               "size": null,  // tamanho do produto\n               "unit": 5,  // unidade\n               "axis": "eixos do produto",\n               "description": "descrição do produto",\n               "year": "ano", \n               "value": 463225.0,  // valor\n               "date_time": "dd-mm-aaaa às hh:mm:ss",\n               "month_reference": 9, //mês de referência\n               "year_reference": 2025, //ano de referência\n               "aggregates_1": null,\n               "aggregates_2": null\n               }\n         ] \n         "hash": "2f19e9ed13dd..."\n    }\n}       `,
    text: '<strong>Passo 1:</strong> Autenticação token;<br/><strong>Passo 2:</strong>  Listagem de Mês/Ano de referência;<br/><strong>Passo 3:</strong>  Requisição de Listagem de Marcas;<br/><strong>Passo 4:</strong> Requisição de Listagem de Modelos por Marca;<br/><strong>Passo 5:</strong> Requisição de listagem de Anos.<br/>Após adquirir todas informações necessárias, basta fazer a requisição para realizar a consulta de preço enviando seguindo o padrão e rota abaixo:',
    step: 6,
  },
  {
    name: 'Consulta Final de Semirreboque',
    header: [
      'Método: GET',
      'Link: https://service.tabelasomos.com.br/table/search/pricing/3/?chassi_or_plate={placa ou chassi do produto}&month_reference={mês}&year_reference={ano}',
      'Códigos dos produtos: 1 = Trator, 2 = Helicóptero, 3 = Semi reboque, 4 = Carroceria, 5 = Ônibus e Caminhão, 6 = Colheitadeira',
      'Headers: {"Content-Type": "application/json, "Authorization":"Token adquirido na rota anterior"}',

    ],
    code: `//Obs: A consulta por placa ou chassi está disponível apenas para semirreboques.\n\nmyHeaders = new Headers({\n   "Content-Type": "application/json"\n   "Authorization":"Token adquirido na rota anterior"\n   })\n\nfetch('https://service.tabelasomos.com.br/table/search/pricing/3/?chassi_or_plate={placa ou chassi do produto}&month_reference={mês}&year_reference={ano}', {\n   method: 'GET',\n   headers: myHeaders,\n   mode: 'cors',\n   cache: 'default'\n}) \n\n Retorno JSON:\n\n{\n   "user": {\n       "id": "6175bf3f-3..."\n       ...\n   },\n   "content": {\n        "pricing": {     \n             "id": "b6bc54a...", \n             "date": "aaaammdd.0",\n             "region": "região",\n             "state": "UF",\n             "city": "cidade",\n             "invoiced": 123456789,  // número do faturamento\n             "fabricator": "fabricantae",\n             "brand_model": "modelo da marca",\n             "year_fabrication": 2024,  // ano de fabricação\n             "axis": 4,  //eixos do produto\n             "product": "produto",\n             "type_vehicle": "tipo do produto",\n             "chassi": "chassi do produto",\n             "plate": AAA1A11,  // placa do produto\n             "month_registration": "mês de inscrição",\n             "year_registration": 2024,  // ano de inscrição\n             "somos_code": [\n                    "código somos"\n             ],\n             "formatted_created_at": "dd-mm-aaaa às hh:mm:ss",\n             "formatted_updated_at": "dd-mm-aaaa às hh:mm:ss"\n         },\n         "values": [\n          {\n             "somos_code": "código somos",\n             "type": "código do produto",\n             "model": "modelo",\n             "size": "tamanho",\n             "unit": "unidade",\n             "axis": "eixos do produto",\n             "description": "descrição do produto",\n             "year": 2024,  // ano\n             "value": 466779.0,  // valor\n             "date_time": "dd-mm-aaaa às hh:mm:ss",\n             "month_reference": 9, //mês de referência\n             "year_reference": 2025, //ano de referência\n             "aggregates_1": null,\n             "aggregates_2": null\n             }\n          ],\n         "hash": "60cfc4ae74a9a..."\n     }\n    \n   }\n `,
    text: '<strong>Passo 1:</strong> Autenticação token; <br/><strong>Passo 2:</strong> Listagem de Mês/Ano de referência. <br/>O usuário deverá realizar a consulta de informações usando a placa ou o chassi do veículo. Para isso, é necessário enviar uma requisição para a API, passando o token no header. O formato da requisição será semelhante ao seguinte exemplo:',
    step: 7,
  },
  {
    name: 'Consulta Final de Caminhões e Ônibus',
    header: [
      'Método: POST',
      'Link: https://service.tabelasomos.com.br/table/search/pricing/3/?chassi_or_plate={placa ou chassi do produto}&month_reference={mês}&year_reference={ano}',
      'Códigos dos produtos: 1 = Trator, 2 = Helicóptero, 3 = Semi reboque, 4 = Carroceria, 5 = Ônibus e Caminhão, 6 = Colheitadeira',
      'Headers: {"Content-Type": "application/json, "Authorization":"Token adquirido na rota de autenticação"}',
    ],
    code: `// Obs: A consulta por placa ou chassi está disponível apenas para caminhões e ônibus.

myHeaders = new Headers({
   "Content-Type": "application/json",
   "Authorization": "Token adquirido na rota de autenticação"
});

fetch('https://service.tabelasomos.com.br/check_view/checkview/query/5/?chassi_or_plate={placa ou chassi do produto}', {
   method: 'POST',
   headers: myHeaders,
   mode: 'cors',
   cache: 'default'
}) 

// Retorno JSON (exemplo fictício):

{
   "user": {
       "id": "fed0700...",
       ...
   },
   "content": {
       "hash": "c570096be9b...",
       "values": [
           {
               "axis": null, //eixos do produto
               "size": null, //tamanho do produto
               "type": "5", 
               "unit": null,
               "year": ano,
               "model": "modelo",
               "value": 3853.0, //valor do produto
               "mounter": "fabricante",
               "date_time": "dd-mm-aaaa às hh:mm:ss",
               "somos_code": null,
               "year_reference": null,
               "month_reference": null,
               "description": null,
               "aggregates_1": null,
               "aggregates_2": {
                   "DsCodigo": "000000-0", //código do produto
                   "DsCombustivel": "G" //combustível do produto
               }
           }
       ],
       "pricing": {
           "id": null,
           "date": null,
           "region": null,
           "state": "estado",
           "city": "cidade",
           "invoiced": null,
           "fabricator": "fabricante",
           "brand_model": "modelo da marca",
           "year_fabrication": "ano de fabricação",
           "axis": null, //eixos do produto
           "product": "NAO IDENTIFICADO",
           "type_vehicle": null,
           "chassi": "chassi",
           "plate": "placa",
           "month_registration": null,
           "year_registration": null,
           "somos_code": null,
           "formatted_created_at": null,
           "formatted_updated_at": null,
           "year_source": null
       }
   }
}
`,
    text: '<strong>Passo 1:</strong> Autenticação token. <br/>O usuário deverá realizar a consulta de informações usando a placa ou o chassi do veículo. Para isso, é necessário enviar uma requisição para a API, passando o token no header. O formato da requisição será semelhante ao seguinte exemplo:',
    step: 8,
  }, {
    name: 'Consulta por Hash',
    header: [
      'Método: GET',
      'Link: https://service.tabelasomos.com.br/log/log/response/{hash}/',
      'Headers: {"Content-Type": "application/json", "Authorization":"Token adquirido na rota anterior"}',
    ],
    code: `myHeaders = new Headers({
   "Content-Type": "application/json",
   "Authorization":"Token adquirido na rota anterior"
})

fetch('https://service.tabelasomos.com.br/log/log/response/{hash}/', {
   method: 'GET',
   headers: myHeaders,
   mode: 'cors',
   cache: 'default'
})

// Retorno JSON esperado
{
   "user": {...},
   "content": {
      "pricing": {...},
      "values": [...],
      "hash": "2f19e9ed13dd..."
   }
}`,
    text: '<strong>Passo 1:</strong> Autenticação token.<br/>O usuário pode consultar diretamente pelo hash. Basta enviar o hash na URL da requisição.',
    step: 9, 
  }, {
    name: 'Consulta por Código Somos - Listagem de Anos Modelos',
    header: [
      'Método: GET',
      'Link: https://service.tabelasomos.com.br/query_somos_code/list/year_model/{Código do produto}/{Código SOMOS}/?year_reference={ano}&month_reference={mês}',
      'Códigos dos produtos disponíveis: 1 = Trator, 2 = Helicóptero, 3 = Semi reboque, 4 = Carroceria, 6 = Colheitadeira',
      'Headers: {"Content-Type": "application/json", "Authorization":"Token adquirido na rota anterior"}',
      'Parâmetros obrigatórios: year_reference, month_reference',
    ],
    code: `//Códigos dos produtos: 1 = Trator, 2 = Helicóptero, 3 = Semi reboque, 4 = Carroceria, 6 = Colheitadeira ,\n
myHeaders = new Headers({
   "Content-Type": "application/json",
   "Authorization":"Token adquirido na rota anterior"
})

fetch('https://service.tabelasomos.com.br/query_somos_code/list/year_model/{Código do produto}/{Código SOMOS}/?year_reference={ano}&month_reference={mês}', {
   method: 'GET',
   headers: myHeaders,
   mode: 'cors',
   cache: 'default'
})

// Retorno JSON esperado
{
  "content": {
    "somos_code": "código somos",
    "years": [
        2023, //ano modelo
        2022, //ano modelo
        ...
    ]
  }
}`,
    text: '<strong>Passo 1:</strong> Autenticação token;<br/><strong>Passo 2:</strong> Listagem de Mês/Ano de referência.<br/>Após obter as datas de referência, basta utilizar o código SOMOS para listar os anos modelos disponíveis.',
    step: 10,
  },
  {
    name: 'Consulta Final por Código Somos',
    header: [
      'Método: GET',
      'Link: https://service.tabelasomos.com.br/query_somos_code/pricing/{Código do produto}/{Código SOMOS}/{Ano desejado}/?year_reference={ano}&month_reference={mês}',
      'Códigos dos produtos disponíveis: 1 = Trator, 2 = Helicóptero, 3 = Semi reboque, 4 = Carroceria, 6 = Colheitadeira',
      'Headers: {"Content-Type": "application/json", "Authorization":"Token adquirido na rota anterior"}',
    ],
    code: `
myHeaders = new Headers({
   "Content-Type": "application/json",
   "Authorization":"Token adquirido na rota anterior"
})

fetch('https://service.tabelasomos.com.br/query_somos_code/consultation/{Código do produto}/{Código somos}/?year_model={Ano modelo}&year_reference={ano de referência}&month_reference={mês de referência}', {
   method: 'GET',
   headers: myHeaders,
   mode: 'cors',
   cache: 'default'
})

// Retorno JSON esperado
{
  "content": {
      "pricing": null,
      "values": [
        {
          "somos_code": "código somos", 
          "type": 1, //tipo do produto
          "mounter": "fabricante",
          "model": "modelo",
          "description": "descrição do produto",
          "year": 2023, //ano modelo
          "value": 463225.0, //valor
          "date_time": "dd-mm-aaaa às hh:mm:ss",
          "month_reference": 9, //mês de referência               
          "year_reference": 2025, //ano de referência
          "aggregates_1": null,
          "aggregates_2": null
        }
      ],
      "hash": "2f19e9ed13dd..."
  }
}`,
    text: '<strong>Passo 1:</strong> Autenticação token;<br/><strong>Passo 2:</strong> Listagem de Mês/Ano de referência;<br/><strong>Passo 3:</strong> Adquirir ano modelo.<br/> Após selecionar o ano modelo desejado, basta realizar a consulta final passando o código SOMOS, produto, ano modelo e datas de referência para obter o preço.',
    step: 11,
  },
  {
    name: 'Requisição de Listagem de Marcas',
    header: [
      'Método: GET',
      'Link: https://service.tabelasomos.com.br/table/search/mounter/"{Código do produto}"/',
      'Código do produto: 7 = Leves(0km)',
      'Headers: {"Content-Type": "application/json, "Authorization":"Token adquirido na rota anterior"}',
      'Parâmetros opcionais: month_reference, year_reference',

    ],
    code: `//Código do produto: 7 = Leves(0km)\n\nmyHeaders = new Headers({\n   "Content-Type": "application/json"\n   "Authorization":"Token adquirido na rota anterior"\n})\n\nfetch('https://service.tabelasomos.com.br/table/search/mounter/"{Código do produto}"/', {\n   method: 'GET',\n   headers: myHeaders,\n   mode: 'cors',\n   cache: 'default'\n}) \n\nRetorno JSON: \n\n{ \n   "user": {\n       "id": "6175bf3f-3..."\n       ...\n   },\n   "content": [\n       {\n           "mounter_code": "código do fabricante",\n           "mounter": "fabricante"\n       },  \n       {\n           "mounter_code": "código do fabricante",\n           "mounter": "fabricante"\n       }, \n       ... \n   ]\n}`,
    text: '<strong>Passo 1:</strong> Autenticação token;<br/><strong>Passo 2:</strong> Listagem de Mês/Ano de referência.<br/>O usuário deverá requerir a listagem de Marcas para realizar a consulta, lembrando sempre de passar o token no header da requisição, que ficará assim:',
    step: 12,
  },
    {
    name: 'Requisição de Listagem de Modelos por Marca',
    header: [
      'Método: GET',
      'Link: https://service.tabelasomos.com.br/table/search/codes/"{Código do produto}"/"{Código da marca desejada}"/',
      'Código do produto: 7 = Leves(0km)',
      'Headers: {"Content-Type": "application/json, "Authorization":"Token adquirido na rota anterior"}',
      'Parâmetros opcionais: month_reference, year_reference',

    ],
    code: `//Código do produto: 7 = Leves(0km)\n\nmyHeaders = new Headers({\n   "Content-Type": "application/json"\n   "Authorization":"Token adquirido na rota anterior"\n})\n\nfetch('https://service.tabelasomos.com.br/table/search/codes/"{Código do produto}"/"{Código da marca desejada}"/', {\n   method: 'GET',\n   headers: myHeaders,\n   mode: 'cors',\n   cache: 'default'\n}) \n\nRetorno JSON: \n\n{ \n   "user": {\n       "id": "6175bf3f-3..."\n       ...\n   },\n   "content": [\n       {\n           "mounter": "fabricante",\n           "model": "modelo"\n           "model_code": "código do modelo"\n           "description": "descrição do produto"       \n       }, \n       {\n           "mounter": "fabricante",\n           "model": "modelo"\n           "model_code": "código do modelo"\n           "description": "descrição do produto"\n       }       \n       ... \n   ]\n}`,
    text: '<strong>Passo 1:</strong> Autenticação token;<br/><strong>Passo 2:</strong>  Listagem de Mês/Ano de referência;<br/><strong>Passo 3:</strong>  Requisição de Listagem de Marcas.<br/>Após ter a Marca desejada em mãos, enviar uma das Marcas na url para que sejam listados os modelos disponíveis daquela Marca, como no código abaixo:',
    step: 13,
  },
{
  name: 'Consulta Final – Leves (0km)',
  header: [
    'Método: GET',
    'Link: https://service.tabelasomos.com.br/table/search/model/price/{Código do produto}/{Código do modelo}/{Ano de referência}/?month_reference={mês}&year_reference={ano}',
    'Códigos dos produtos: 7 = Leves (0km)',
    'Headers: {"Content-Type": "application/json", "Authorization":"Token adquirido na rota anterior"}',
    'Observação: Para Leves (0km), o parâmetro {year} representa o ANO DE REFERÊNCIA'
  ],
  code: `// Código do produto: 7 = Leves (0km)
// {year} = ano de referência

myHeaders = new Headers({
  "Content-Type": "application/json",
  "Authorization":"Token adquirido na rota anterior"
});

fetch(
  'https://service.tabelasomos.com.br/table/search/model/price/7/{model_code}/{year_reference}/?month_reference={mês}&year_reference={ano}',
  {
    method: 'GET',
    headers: myHeaders,
    mode: 'cors',
    cache: 'default'
  }
)

// Retorno JSON esperado

{
  "user": {
    "id": "b455d27c...",
    ...
  },
  "content": {
    "hash": "2f19e9ed13dd...",
    "values": [
      {
        "somos_code": "código somos",
        "type": "7",
        "vehicle_type": "tipo de veículo",
        "year": ano ,
        "description": "descrição",
        "mounter": "fabricante",
        "model": "modelo",
        "initial_value": valor inicial,
        "current_month_value": valor referente ao mês atual,
        "variation_percent": percentual da variação,
        "variation_type": "tipo de variação",
        "month_reference": mês de referência,
        "year_reference": ano de referência,
        "em_producao": "em produção?",
        "date_time": "dd-mm-aaaa às hh:mm:ss",
        "substitutes": [
          {
            "index": número do index,
            "model": "modelo substituto",
            "mounter": "fabricante",
            "current_value": valor atual,
            "variation_percent": percentual
          }
        ]
      }
    ]
  }
}
`,
  text:
    '<strong>Passo 1:</strong> Autenticação token;<br/>' +
    '<strong>Passo 2:</strong> Listagem de Mês/Ano de referência;<br/>' +
    '<strong>Passo 3:</strong> Requisição de Listagem de Marcas;<br/>' +
    '<strong>Passo 4:</strong> Requisição de Listagem de Modelos por Marca;<br/><br/>' +
    'Para o produto <strong>Leves (0km)</strong>, a consulta final utiliza o ' +
    '<strong>ano de referência no path da URL</strong>. O retorno apresenta ' +
    'valor inicial, valor do mês corrente e variação percentual.',
  step: 14
},
];